// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Image Section */

.image-section {
  width: 100%;
}

/* Upload Zone */
.image-upload-zone {
  border: 2px dashed var(--color-text-secondary);
  border-radius: 0.5rem;
  padding: 2rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s;
  margin-bottom: 1rem;
  background: transparent;
}

.image-upload-zone:hover {
  border-color: var(--color-primary);
  background: rgba(var(--color-primary-rgb, 44, 85, 48), 0.05);
}

.image-upload-zone.drag-active {
  border-color: var(--color-primary);
  background: rgba(var(--color-primary-rgb, 44, 85, 48), 0.1);
  border-style: solid;
}

.image-upload-prompt {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  color: var(--color-text-secondary);
}

.image-upload-icon {
  font-size: 2.5rem;
  font-weight: 300;
  line-height: 1;
  color: var(--color-text-secondary);
}

.image-upload-hint {
  font-size: 0.8rem;
  opacity: 0.7;
}

.image-upload-status {
  color: var(--color-primary);
  font-weight: 500;
}

.image-upload-error {
  color: var(--color-error, #e74c3c);
  font-size: 0.9rem;
  margin-bottom: 1rem;
  text-align: center;
}

/* Gallery Grid */
.image-gallery {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  margin-top: 1rem;
}

@media (max-width: 600px) {
  .image-gallery {
    grid-template-columns: repeat(2, 1fr);
  }
}

.image-gallery-item {
  position: relative;
  background: var(--color-background, #f5f5f5);
  border-radius: 0.5rem;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.image-gallery-thumb {
  aspect-ratio: 1;
  overflow: hidden;
  cursor: pointer;
}

.image-gallery-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.2s;
}

.image-gallery-thumb:hover img {
  transform: scale(1.05);
}

.image-gallery-meta {
  padding: 0.5rem;
}

.image-meta-display {
  cursor: pointer;
  min-height: 2rem;
}

.image-meta-title {
  display: block;
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--color-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.image-meta-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.15rem;
}

.image-meta-date-display {
  font-size: 0.75rem;
  color: var(--color-text-secondary);
}

.image-meta-size {
  font-size: 0.7rem;
  color: var(--color-text-secondary);
  opacity: 0.7;
}

.image-meta-placeholder {
  font-style: italic;
  opacity: 0.6;
}

.image-meta-input {
  width: 100%;
  padding: 0.25rem 0.4rem;
  border: 1px solid var(--color-primary);
  border-radius: 0.25rem;
  font-size: 0.85rem;
  background: var(--color-card-bg);
  color: var(--color-text);
  margin-bottom: 0.25rem;
  box-sizing: border-box;
}

.image-meta-date {
  font-size: 0.8rem;
}

.image-delete-btn {
  position: absolute;
  top: 0.25rem;
  right: 0.25rem;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 1.5rem;
  height: 1.5rem;
  font-size: 1rem;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s;
}

.image-gallery-item:hover .image-delete-btn {
  opacity: 1;
}

/* Lightbox */
.image-lightbox {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  z-index: 100000;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.image-lightbox-content {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  cursor: default;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.image-lightbox-content img {
  max-width: 90vw;
  max-height: 80vh;
  object-fit: contain;
  border-radius: 0.25rem;
}

.image-lightbox-close {
  position: fixed;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  color: #fff;
  font-size: 2rem;
  cursor: pointer;
  z-index: 100001;
  line-height: 1;
  padding: 0.5rem;
}

.image-lightbox-prev,
.image-lightbox-next {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.15);
  border: none;
  color: #fff;
  font-size: 2.5rem;
  cursor: pointer;
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  z-index: 100001;
  line-height: 1;
}

.image-lightbox-prev {
  left: 1rem;
}

.image-lightbox-next {
  right: 1rem;
}

.image-lightbox-prev:hover,
.image-lightbox-next:hover {
  background: rgba(255, 255, 255, 0.3);
}

.image-lightbox-caption {
  color: #fff;
  text-align: center;
  margin-top: 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.image-lightbox-title {
  font-size: 1.1rem;
  font-weight: 500;
}

.image-lightbox-date {
  font-size: 0.9rem;
  opacity: 0.8;
}

.image-lightbox-counter {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.85rem;
  margin-top: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/Studio/ImageSection.css"],"names":[],"mappings":"AAAA,kBAAkB;;AAElB;EACE,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,8CAA8C;EAC9C,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,4DAA4D;AAC9D;;AAEA;EACE,kCAAkC;EAClC,2DAA2D;EAC3D,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,qBAAqB;EACrB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,sCAAsC;EACtC,sBAAsB;EACtB,kBAAkB;EAClB,gCAAgC;EAChC,wBAAwB;EACxB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA,aAAa;AACb;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,qCAAqC;EACrC,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":["/* Image Section */\n\n.image-section {\n  width: 100%;\n}\n\n/* Upload Zone */\n.image-upload-zone {\n  border: 2px dashed var(--color-text-secondary);\n  border-radius: 0.5rem;\n  padding: 2rem;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.2s;\n  margin-bottom: 1rem;\n  background: transparent;\n}\n\n.image-upload-zone:hover {\n  border-color: var(--color-primary);\n  background: rgba(var(--color-primary-rgb, 44, 85, 48), 0.05);\n}\n\n.image-upload-zone.drag-active {\n  border-color: var(--color-primary);\n  background: rgba(var(--color-primary-rgb, 44, 85, 48), 0.1);\n  border-style: solid;\n}\n\n.image-upload-prompt {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n  color: var(--color-text-secondary);\n}\n\n.image-upload-icon {\n  font-size: 2.5rem;\n  font-weight: 300;\n  line-height: 1;\n  color: var(--color-text-secondary);\n}\n\n.image-upload-hint {\n  font-size: 0.8rem;\n  opacity: 0.7;\n}\n\n.image-upload-status {\n  color: var(--color-primary);\n  font-weight: 500;\n}\n\n.image-upload-error {\n  color: var(--color-error, #e74c3c);\n  font-size: 0.9rem;\n  margin-bottom: 1rem;\n  text-align: center;\n}\n\n/* Gallery Grid */\n.image-gallery {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n@media (max-width: 600px) {\n  .image-gallery {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n.image-gallery-item {\n  position: relative;\n  background: var(--color-background, #f5f5f5);\n  border-radius: 0.5rem;\n  overflow: hidden;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.image-gallery-thumb {\n  aspect-ratio: 1;\n  overflow: hidden;\n  cursor: pointer;\n}\n\n.image-gallery-thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.2s;\n}\n\n.image-gallery-thumb:hover img {\n  transform: scale(1.05);\n}\n\n.image-gallery-meta {\n  padding: 0.5rem;\n}\n\n.image-meta-display {\n  cursor: pointer;\n  min-height: 2rem;\n}\n\n.image-meta-title {\n  display: block;\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: var(--color-text);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.image-meta-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 0.15rem;\n}\n\n.image-meta-date-display {\n  font-size: 0.75rem;\n  color: var(--color-text-secondary);\n}\n\n.image-meta-size {\n  font-size: 0.7rem;\n  color: var(--color-text-secondary);\n  opacity: 0.7;\n}\n\n.image-meta-placeholder {\n  font-style: italic;\n  opacity: 0.6;\n}\n\n.image-meta-input {\n  width: 100%;\n  padding: 0.25rem 0.4rem;\n  border: 1px solid var(--color-primary);\n  border-radius: 0.25rem;\n  font-size: 0.85rem;\n  background: var(--color-card-bg);\n  color: var(--color-text);\n  margin-bottom: 0.25rem;\n  box-sizing: border-box;\n}\n\n.image-meta-date {\n  font-size: 0.8rem;\n}\n\n.image-delete-btn {\n  position: absolute;\n  top: 0.25rem;\n  right: 0.25rem;\n  background: rgba(0, 0, 0, 0.6);\n  color: #fff;\n  border: none;\n  border-radius: 50%;\n  width: 1.5rem;\n  height: 1.5rem;\n  font-size: 1rem;\n  line-height: 1;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: opacity 0.2s;\n}\n\n.image-gallery-item:hover .image-delete-btn {\n  opacity: 1;\n}\n\n/* Lightbox */\n.image-lightbox {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.9);\n  z-index: 100000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.image-lightbox-content {\n  position: relative;\n  max-width: 90vw;\n  max-height: 90vh;\n  cursor: default;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.image-lightbox-content img {\n  max-width: 90vw;\n  max-height: 80vh;\n  object-fit: contain;\n  border-radius: 0.25rem;\n}\n\n.image-lightbox-close {\n  position: fixed;\n  top: 1rem;\n  right: 1rem;\n  background: none;\n  border: none;\n  color: #fff;\n  font-size: 2rem;\n  cursor: pointer;\n  z-index: 100001;\n  line-height: 1;\n  padding: 0.5rem;\n}\n\n.image-lightbox-prev,\n.image-lightbox-next {\n  position: fixed;\n  top: 50%;\n  transform: translateY(-50%);\n  background: rgba(255, 255, 255, 0.15);\n  border: none;\n  color: #fff;\n  font-size: 2.5rem;\n  cursor: pointer;\n  padding: 0.5rem 1rem;\n  border-radius: 0.25rem;\n  z-index: 100001;\n  line-height: 1;\n}\n\n.image-lightbox-prev {\n  left: 1rem;\n}\n\n.image-lightbox-next {\n  right: 1rem;\n}\n\n.image-lightbox-prev:hover,\n.image-lightbox-next:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.image-lightbox-caption {\n  color: #fff;\n  text-align: center;\n  margin-top: 0.75rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.image-lightbox-title {\n  font-size: 1.1rem;\n  font-weight: 500;\n}\n\n.image-lightbox-date {\n  font-size: 0.9rem;\n  opacity: 0.8;\n}\n\n.image-lightbox-counter {\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 0.85rem;\n  margin-top: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
